import { AuthUser } from '../auth/auth.type';

export type UserBrand = {
    brandId: number;
    name: string;
};
export type UserRestaurant = {
    restaurantId: number;
    name: string;
    brandId: number; // TODO: this type is wrong, it is optional
};
export type User = {
    userId: number;
    email: string;
    role: UserRoles;
    accessFlags: AuthUser['accessFlags'];
    accessToken: string;
    brands: UserBrand[];
    restaurants: UserRestaurant[];
    firstName: string;
    lastName: string;
    phone: string;
    brandId: number | null;
};

export enum UserRoles {
    admin = 'admin',
    brand = 'brand',
    restaurant = 'restaurant',
    brandGroup = 'brandGroup',
    kiosk = 'kiosk',
}

export type GetUserPayload = { userId: number };
export type UpdateUserPayload = Omit<User, 'accessFlags'> & { accessFlags: Record<string, boolean> };
export type GetBrandsUsersListPayload = {
    brandId: number;
    search?: string;
    orderByLastConnection: boolean;
    role?: UserRoles;
};
export type GetBrandsUsersListResponse = {
    firstName: string;
    lastName: string;
    email: string;
    userId: number;
    lastConnection: string;
    role: UserRoles;
}[];

export type GetRestaurantUsersPayload = { brandId: number; restaurantId: number };
export type GetRestaurantUsersResponse = {
    email: string;
    userId: number;
    firstName: string;
    lastName: string;
}[];

export type GetRestaurantUsersListPayload = {
    brandId: number;
    restaurantId: number;
    search?: string;
    orderByLastConnection: boolean;
};
export type GetRestaurantUsersListResponse = {
    firstName: string;
    lastName: string;
    email: string;
    userId: number;
    lastConnection: string;
    role: UserRoles;
}[];

export type GetUserRestaurantsPayload = { userId: number };
export type GetUserRestaurantsResponse = {
    restaurantId: number;
    name: string;
}[];

export type UpdateUserRestaurantsPayload = { userId: number; restaurantIds: number[] };

export type CreateManagerPayload = {
    badgeNumber: number;
    brandId: number;
    email: string;
    firstName: string;
    lastName: string;
    phone: string;
    role: string;
    password: string | null;
    confirmPassword: string | null;
    letUserChoosePassword?: boolean;
    restaurantId?: number;
};

export type UpdatePasswordPayload = {
    userId: number;
    oldPassword: string;
    newPassword: string;
    role: UserRoles;
};

export type PasswordPolicy = {
    minLength?: number;
    maxLength?: number;
    requireUppercase?: boolean;
    requireLowercase?: boolean;
    requireNumbers?: boolean;
    requireSpecialCharacters?: boolean;
};

export type ValidateActivationTokenPayload = {
    token: string;
};

export type ValidateActivationTokenResponse = {
    isValid: boolean;
    canRenew: boolean;
    passwordPolicy?: PasswordPolicy;
};

export type ActivateAccountPayload = {
    token: string;
    password: string;
    confirmPassword: string;
};

export type RenewActivationTokenPayload = {
    token: string;
};
